<template>
  <section id="pesanan">
    <Navbar />
    <div class="container mt-3">
      <div class="title-section">
        <h3>Daftar <strong>Pesanan</strong></h3>
      </div>

      <!-- Breadcrumb -->
      <nav aria-label="breadcrumb" class="my-3">
        <ol class="breadcrumb bg-transparent">
          <li class="breadcrumb-item">
            <router-link to="/"><span class="link">Home</span></router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/foods"
              ><span class="link">Foods</span></router-link
            >
          </li>
          <li class="breadcrumb-item active">
            <span class="link-active">Pesanan</span>
          </li>
        </ol>
      </nav>

      <!-- Tabel Pesanan -->
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">No</th>
              <th scope="col" class="text-center">Gambar</th>
              <th scope="col">Nama Makanan</th>
              <th scope="col">Keterangan</th>
              <th scope="col">Jumlah</th>
              <th scope="col" class="text-center">Harga</th>
              <th scope="col">Total Harga</th>
              <th scope="col" class="text-center">Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(pesan, index) in pesanan" :key="pesan.id">
              <td>{{ index + 1 }}</td>
              <td>
                <img
                  :src="require(`../assets/images/${pesan.product.gambar}`)"
                  alt="img-food"
                  class="img-fluid rounded shadow"
                  width="250px"
                />
              </td>
              <td>
                <strong>{{ pesan.product.nama }}</strong>
              </td>
              <td>{{ pesan.catatan ? pesan.catatan : "Tidak Ada" }}</td>
              <td align="center">{{ pesan.jumlah_pesanan }}</td>
              <td align="right">Rp. {{ formatPrice(pesan.product.harga) }}</td>
              <td align="right">
                <strong
                  >Rp.
                  {{
                    formatPrice(pesan.product.harga * pesan.jumlah_pesanan)
                  }}</strong
                >
              </td>
              <td align="right">
                <button class="btn btn-danger" @click="hapusPesanan(pesan.id)">
                  <b-icon icon="trash"></b-icon>
                  Hapus
                </button>
              </td>
            </tr>

            <tr>
              <td colspan="6" align="right">Total Harga :</td>
              <td colspan="1" align="right">
                <strong>Rp. {{ formatPrice(totalHarga) }}</strong>
              </td>
              <td colspan="1"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div class="form-pesanan row justify-content-end">
        <div class="col-md-5">
          <form action="post" class="mt-3" v-on:submit.prevent>
            <label for="nama-pemesan" class="form-label">Nama Pemesan :</label>
            <input
              v-model="total_pesanan.nama"
              id="nama-pemesan"
              class="form-control"
              type="text"
              placeholder="Nama Lengkap"
            />
            <label for="no-meja-pemesan" class="form-label mt-3"
              >Nomor Meja :</label
            >
            <input
              v-model="total_pesanan.no_meja"
              id="no-meja-pemesan"
              class="form-control"
              type="number"
              placeholder="Nomor Meja"
            />
            <button
              class="btn btn-success btn-block mt-4"
              type="submit"
              @click="pesanMakanan"
            >
              <b-icon icon="cart"></b-icon>
              Pesan Makanan
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { API_URL } from "../utils/constant.js";

import Navbar from "../components/Navbar.vue";

export default {
  name: "Pesanan",
  components: {
    Navbar,
  },
  data() {
    return {
      pesanan: {},
      total_pesanan: {},
    };
  },
  methods: {
    setPesanan(data) {
      this.pesanan = data;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    hapusPesanan(id) {
      axios
        .delete(API_URL + "/pesanan/" + id)
        .then(() => {
          this.$router.push({ path: "/foods" });
          this.$toast.success(`Berhasil Hapus Pesanan`, {
            position: "top-right",
          });
        })
        .catch(() => {
          this.$toast.error(`Gagal Hapus Pesanan`, {
            position: "top-right",
          });
        });
    },
    pesanMakanan() {
      if (
        this.pesanan &&
        this.total_pesanan.nama &&
        this.total_pesanan.no_meja
      ) {
        // Push Data Pesanan
        this.total_pesanan.pesanan = this.pesanan;
        axios.post(API_URL + "/total-pesanan", this.total_pesanan).then(() => {
          this.$router.push({ path: "/pesanan-sukses" });
          this.$toast.success("Makanan sudah dipesan :)", {
            position: "top-right",
          });
        });

        // Hapus List Keranjang
        this.pesanan.map((item) => {
          return axios.delete(API_URL + "/pesanan/" + item.id).catch((err) => {
            console.log(`err`, err);
          });
        });
      } else {
        this.$toast.error("Nama dan Nomor Meja harus diisi", {
          position: "top-right",
        });
      }
    },
  },
  mounted() {
    axios
      .get(API_URL + "/pesanan")
      .then((res) => {
        console.log(`Daftar Pesanan`, res.data);
        this.setPesanan(res.data);
      })
      .catch((err) => {
        console.log(`Failed Get Daftar Pesanan`, err);
      });
  },
  computed: {
    totalHarga() {
      return this.pesanan.reduce((items, data) => {
        return items + data.product.harga * data.jumlah_pesanan;
      }, 0);
    },
  },
};
</script>

<style></style>
